import * as React from "react";
import "../App.css";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Modal } from '@mui/material';
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Checkbox, Stack } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useOtpSettings } from './OtpContext';
import Divider from "@mui/material/Divider";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function FeePayment({ props }) {
  let {
    studentId,
    feesSlabId,
    studentName,
    feesSlabAmount,
    currentPendingAmount,
    setCurrentPendingAmount,
    remarks,
    setRemark,
    refundBalance,
    setRefundBalance,
    academicYearId,
    gradeName,
    gradeId,
    pendingFees,
    userId,sectionName, sectionId,userMail
 
  } = props;
  const [feeSlab, setFeeSlab] = useState(feesSlabAmount);
  const [studentConcession, setStudentConcession] = useState(0);
  const [amountAfterConcession, setAmountAfterConcession] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [amountPending, setAmountPending] = useState(0);
  const [refundBalanceInclude, setRefundBalanceInclude] = useState(false);
  const [paymentMode, setPaymentMode] = useState([]);
  const [utrId, setUrtId] = useState("");
  const [description, setDescription] = useState("");
  const [oldStudentConcession, setOldStudentConcession] = useState(0);
  const [oldTotalAmountPaid, setOldTotalAmountPaid] = useState(0);
  const [oldAmountPending, setOldAmountPending] = useState(0);
  const [oldPaymentMode, setOldPaymentMode] = useState([]);
  const [oldUtrId, setOldUrtId] = useState("");
  const [oldDescription, setOldDescription] = useState('');
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("fees_slab");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [feesPayment, setFeesPayment] = useState([{}]);
  const [feePaymentId, setFeePaymentId] = useState(0);
  const [paymentModeId, setPaymentModeId] = useState();
  const [paymentModeName, setPaymentModeName] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [feesSlabModal, setFeesSlabModal] = useState(false);

  const [totalAmountPaidError, setTotalAmountPaidError] = useState(false);
  const [paymentDateError, setPaymentDateError] = useState(false);
  const [paymentModeError, setPaymentModeError] = useState(false);
  const [feesSlabError, setFeesSlabError] = useState(false);

  const [studentConcessionError, setStudentConcessionError] = useState("");
  const [transactionIdError, setTransactionIdError] = useState("");
  const [remainingRefundBalance, setRemainingRefundBalance] =
    useState(refundBalance);
  const [usedRefundAmount, setUsedRefundAmount] = useState(0);

  const [isEditing, setIsEditing] = useState(false);

  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  // const [email, setEmail] = useState(process.env.REACT_APP_EMAIL);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1); // Counter for resend attempts
const [currentPending, setCurrentPending]= useState(0);
const [update, setUpdate]= useState(false);
const [staticPendingAmount, setStaticPendingAmount] = useState(null);
const [staticPendinAfterConcession, setStaticPendingAfterConcession] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const instituteId = localStorage.getItem('instituteId');
const instituteEmailMap = {
  "1": process.env.REACT_APP_EMAIL_JHS,
  "2": process.env.REACT_APP_EMAIL_JPS,
};
const [email, setEmail] = useState(instituteEmailMap[instituteId]);

  useEffect(() => {
    // Reset to default sorting when students are fetched
    setOrder("desc");
    setOrderBy("fees_payment_id");
  }, [feesPayment]);

  const navigate = useNavigate();
  useEffect(() => {
  const getFeesReport = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/feesReport/getFeesReport", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: 'include',  // Important to send cookies with the request
      body: JSON.stringify({
        academic_year_id: academicYearId,
        grade_id: gradeId ? gradeId : null,
        fees_slab_id: feesSlabId ? feesSlabId : null,
        section_id:sectionId ? sectionId : null,
        pending_fees: pendingFees ? true : false,
        // Narrows the DB query to just this student instead of asking for
        // (and decrypting) the entire matching roster to find one row.
        student_id: studentId,
      }),
    })
      .then((response) => response.json())
      .then((response) => {

       const targetStudentId = studentId; // Replace with the actual student ID you're checking for

       // getFeesReport now returns { rows, total } instead of a bare array
       // (added for pagination); this endpoint is called here with no page
       // params at all, expecting the full list back, so unwrap .rows.
       const rows = Array.isArray(response) ? response : response?.rows || [];

       // Find the student whose studentId matches the target
       const matchingStudent = rows.find(
         (student) => student.student_id === targetStudentId
       );
       
       if (matchingStudent) {
         const updatedRefund = matchingStudent.refund_amount;
       
         if (updatedRefund !== undefined) {
           setRefundBalance((prev) => {
             return updatedRefund;
           });
           console.log("updatedRefund for Student:", updatedRefund, studentId);
      
         } else {
           console.error("current_pending_amount not found for the matched student.");
         }
       } else {
         console.error("No student found with the specified studentId.");
       }
      });
  };
  getFeesReport();

}, [academicYearId, gradeId, feesSlabId,sectionId,pendingFees]);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure 2-digit day
    return `${year}-${month}-${day}`;
    
  };
  const [paymentDate, setPaymentDate] = useState(getTodayDate);
  const [oldPaymentDate, setOldPaymentDate] = useState('');



  const handleRefundChange = () => {
    setRefundBalanceInclude(!refundBalanceInclude);
  };

  //Simran........ added pagination and sorting
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting function
  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  // Sort the rows before displaying them
  const sortedRows = feesPayment
    .map((row, index) => ({ ...row, index: index + 1 })) // Add index for Serial No.
    .sort(getComparator(order, orderBy));

  const handleChange = (event) => {
    const selectedMode = event.target.value;
    setPaymentModeName(selectedMode);
    let selectedPaymentMode = paymentMode.find(
      (pm) => pm.payment_mode_name === event.target.value
    );
    setPaymentModeId(selectedPaymentMode.payment_mode_id);
    setPaymentModeError("");
    if (selectedMode === 'Cash' || selectedMode === 'Using Refund Balance') {
      setUrtId(''); // Clear the transaction ID when payment mode is Cash
    }
  };
 

  useEffect(() => {
    getFeePayment();
  }, [academicYearId, studentId]);

  
  const getFeePayment = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/feePayment/getFeePayment", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include", // Important to send cookies with the request
        body: JSON.stringify({
          academic_year_id: academicYearId,
          student_id: studentId,
        }),
      });
  
      // Check if response status is 401 before parsing JSON
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect to sign-in
        return; // Stop further execution
      }
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      setFeesPayment(data); // Store the fetched data
    } catch (error) {
      console.error("Error fetching fee payment data:", error);
    }
  };
  
  const handleSelectRow = (
    feesPaymentId,
    amountPaid,
    pendingAmount,
    remarks,
    // usedRefundAmount,
    feeConcession,
    paymentModeName,
    paymentDate,
    transactionId,
    description,
   
  ) => {
    setIsEditing(true);

    setFeePaymentId(feesPaymentId);

    setTotalAmountPaid(amountPaid);

  
    setAmountPending(pendingAmount);

  
    setRemark(remarks);

   
    setPaymentModeName(paymentModeName);

    setStudentConcession(feeConcession); // Set fee concession

  
    
    setUrtId(transactionId); // Set the transaction ID
 
    setDescription(description); // Set the description
    const formattedDate = new Date(paymentDate).toISOString().split("T")[0];
    setPaymentDate(formattedDate); // Set the formatted date
    // setRefundBalance(usedRefundAmount)
    
      //  Setting previous values of all states
        setOldAmountPending(pendingAmount);
        setOldStudentConcession(feeConcession);
        setOldTotalAmountPaid(amountPaid);
        setOldPaymentDate(paymentDate);
        setOldPaymentMode(paymentModeName);
        setOldUrtId(transactionId);
        setOldDescription(description)

        setTotalAmountPaidError("");
        setPaymentModeError("")
        setFeesSlabError("");
      
  };


const savePaymentDetails = () => {
  fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/feePayment/editFeePayment", {
    method: "POST",
    headers: { "Content-type": "application/json" },
    body: JSON.stringify({
      fees_payment_id: feePaymentId,
      academic_year_id: academicYearId,
      description: description,
      payment_mode_id: paymentModeId,
      transaction_id: utrId,
      payment_date: paymentDate,
      updated_timestamp: new Date(),
      updated_by: userId,
      grade_id: gradeId ? gradeId : null,
      fees_slab_id: feesSlabId ? feesSlabId : null,
      section_id: sectionId ? sectionId : null,
      pending_fees: pendingFees ? true : false,
      student_id: studentId,
    }),
  })
    .then((response) => {
     
      return response.json();
    })
    .then((response) => {
      if (!response) return; // Stop execution if redirected
      
      handleResponse(response);

      const targetStudentId = studentId;
      const matchingStudent = response.getStudentFees?.find(
        (student) => student.student_id === targetStudentId
      );

      if (matchingStudent) {
        const currentPendingAmountUpdated = matchingStudent.current_pending_amount;

        if (currentPendingAmountUpdated !== undefined) {
          setCurrentPending((prev) => {
            console.log("Previous Pending:", prev, "New Pending:", currentPendingAmountUpdated);
            return currentPendingAmountUpdated;
          });
          console.log("Set Current Pending Amount for Student:", currentPendingAmountUpdated);
        } else {
          console.error("current_pending_amount not found for the matched student.");
        }
      } else {
        console.error("No student found with the specified studentId.");
      }
    })
    .catch((error) => {
      console.error("Error updating payment details:", error);
    });
};

  useEffect(() => {
    
    if(!isEditing && update){
     let pending = currentPending;
        setAmountPending(pending);   
    }
  }, [currentPending, isEditing, update]);
  
  const addPaymentDetails = () => {
    let totalAmountPaidError = "";
    let paymentDateError = "";
    let paymentModeError = "";
    let transactionIdError = "";
    let feesSlabError = "";

    // Validate Total Amount Paid
    if (!refundBalanceInclude) {
      if ((!totalAmountPaid || parseFloat(totalAmountPaid) === 0) && parseFloat(studentConcession) !== currentPendingAmount) {
        totalAmountPaidError = "Amount Paid is required";
      }
    }
    

    if (
      !amountAfterConcession &&
      parseFloat(totalAmountPaid) > currentPendingAmount
    ) {
      totalAmountPaidError = "Amount can't exceed amount pending.";
      // totalAmountPaid = Number(totalAmountPaid.slice(0, String(currentPendingAmount).length)); // Truncate the value
    } else if (
      amountAfterConcession &&
      parseFloat(totalAmountPaid) > amountAfterConcession
    ) {
      totalAmountPaidError =
        "Amount can't exceed amount after concession.";
      // totalAmountPaid = Number( totalAmountPaid.slice(0, String(amountAfterConcession).length)); // Truncate the value
    } else {
      delete totalAmountPaidError.totalAmountPaid;
    }

    // Validate Payment Date
    if (!paymentDate || paymentDate.trim() === "") {
      paymentDateError = "Payment Date is required";
    }
  
    if (
      (paymentModeName === "UPI" || paymentModeName === "DD/Cheque") &&
      (!utrId || utrId.trim() === "")
    ) {
      transactionIdError = paymentModeName === "DD/Cheque" 
        ? "DD/Cheque number is required." 
        : "Transaction ID is required.";
    }

    // Validate Payment Mode
    if (
      !paymentModeId ||
      paymentModeId === "" ||
      parseFloat(paymentModeId) === 0
    ) {
      paymentModeError = "Payment Mode is required";
    }
    if (refundBalanceInclude) {
      if (parseFloat(totalAmountPaid) > parseFloat(staticPendingAmount) && 
       parseFloat(staticPendingAmount) !== 0 && parseFloat(amountPending)=== 0) {
        totalAmountPaidError = "Amount can't exceed amount pending.";
      }else if(parseFloat(amountPending)> 0 && parseFloat(totalAmountPaid)=== 0){
        totalAmountPaidError = "Amount Paid is required.";
      }else if (parseFloat(amountPending)> 0 && isNaN(parseFloat(totalAmountPaid))) { 
        totalAmountPaidError = "Amount Paid is required.";
    }else if (parseFloat(totalAmountPaid) > parseFloat(staticPendinAfterConcession) ) { 
      totalAmountPaidError = "Amount can't exceed amount pending.";
  }
    }
    
    if ((!feesSlabAmount || parseFloat(feesSlabAmount) === 0 || feesSlabAmount === "")){
      feesSlabError = "Fees Slab is required";
      setSnackbarMessage("Fees slab must be added for this student before proceeding with the payment.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);

    }
    // Set errors and return if any validations fail
    if (
      totalAmountPaidError ||
      paymentDateError ||
      paymentModeError ||
      transactionIdError ||
      feesSlabError
    ) {
      setTotalAmountPaidError(totalAmountPaidError);
      setPaymentDateError(paymentDateError);
      setTransactionIdError(transactionIdError);
      setPaymentModeError(paymentModeError);
      setFeesSlabError(feesSlabError);
      return; // Prevent form submission if there are errors
    }

    // Reset error state after successful validation
    setTotalAmountPaidError("");
    setPaymentDateError("");
    setPaymentModeError("");
    setTransactionIdError("");
    setFeesSlabError("");

     setIsLoading(true); // Start loading
    fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/feePayment/saveFeePayment`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        fees_payment_id: feePaymentId,
        student_id: studentId,
        fees_slab_id: feesSlabId,
        fees_slab: feesSlabAmount,
        fee_concession: isNaN(studentConcession) ? 0 : studentConcession,
        amount_after_concession: amountAfterConcession,
        amount_paid: totalAmountPaid,
        amount_pending: amountPending,
        payment_mode_id: paymentModeId,
        transaction_id: utrId,
        payment_date: paymentDate,
        refund_amount: refundBalance,
        refund_amount_used: usedRefundAmount,
        refund_amount_remaining: remainingRefundBalance,
        isRefundBalanceInclude: refundBalanceInclude,
        academic_year_id: academicYearId,
        description: description,
        created_by: userId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect to sign-in
          return null; // Stop further execution
        }
        return response.json();
      })
      .then((response) => {
        if (!response) return; // Prevent further execution if redirected
        handleResponse(response);
      })
      .catch((error) => {
        console.error("Error submitting payment details:", error);
      })
      .finally(() => {
      setIsLoading(false); // Stop loading
    });
    
  };
 
  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      getFeePayment();
      setFeesSlabModal(false);
      setSnackbarMessage(responseObject.message);
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
      reset();
    }
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  };

  const reset = () => {
    setTotalAmountPaidError("");
    setPaymentDateError("");
    setPaymentModeError("");
    setFeesSlabError("");
    setTransactionIdError("");
    setStudentConcession(0);
    setAmountAfterConcession(0);
    setTotalAmountPaid(0);
    setFeePaymentId("");
    setPaymentModeName("");
    setUrtId("");
    setDescription("");
    setPaymentDate(getTodayDate)
    setTimeout(() => {
      if(!feePaymentId){
      setCurrentPendingAmount(amountPending);
      setRefundBalance(remainingRefundBalance);
      }
      setIsEditing(false);
    }, 2000);
  };

  const handleStudentConcessionChange = (event) => {
    // simran..added validations
    const value = event.target.value;
    let numericValue = parseFloat(value);

    let error = ""; // Use a string for a single error message
    if (amountPending === 0) {
      error = ""; // Cancel any error if amountPending is zero
    }

    const parsedAmountPaid = parseFloat(totalAmountPaid) || 0;

    // Perform validation
    if (numericValue > (currentPendingAmount - parsedAmountPaid)) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(
        value.slice(0, String(currentPendingAmount).length)
      ); // Truncate the value
    } else if (numericValue < -0) {
      error = "Concession should not be negative.";
      numericValue = Number(
        value.slice(0, String(currentPendingAmount).length)
      ); // Truncate the value
    }else if(refundBalanceInclude && numericValue > (currentPendingAmount - usedRefundAmount)){
      error = "Concession can't exceed amount pending.";
      numericValue = Number(value.slice(0, String(currentPendingAmount).length)); // Truncate the value
    }else if(refundBalanceInclude && totalAmountPaid > 0 &&  numericValue > (currentPendingAmount - usedRefundAmount - parsedAmountPaid)){
      error = "Concession can't exceed amount pending.";
      numericValue = Number(value.slice(0, String(currentPendingAmount).length)); // Truncate the value
    } else {
      delete error.studentConcession;
    }
    setStaticPendingAfterConcession(currentPendingAmount - numericValue - usedRefundAmount);
    // Update state
    setStudentConcession(numericValue); // Set the updated value
    setStudentConcessionError(error); // Set the error message
     
  };

  const handleAmountPaidChange = (event) => {
    const value = event.target.value;
    let numericValue = parseFloat(value); // Use `let` for reassignment

    let error = ""; // Use a string for a single error message

    // Perform validation
    if (!amountAfterConcession && parseFloat(value) > currentPendingAmount) {
      error = "Amount can't exceed amount pending.";
      numericValue = Number(
        value.slice(0, String(currentPendingAmount).length)
      ); // Truncate the value
    } else if (
      amountAfterConcession &&
      parseFloat(value) > amountAfterConcession
    ) {
      error = "Amount can't exceed amount after concession.";
      numericValue = Number(
        value.slice(0, String(amountAfterConcession).length)
      ); // Truncate the value
    }
    else {
      delete error.totalAmountPaid;
    }
    if(refundBalanceInclude){
      if (
        staticPendingAmount &&
        parseFloat(value) > staticPendingAmount
      ) {
        error = "Amount can't exceed amount pending.";
        numericValue = Number(
          value.slice(0, String(staticPendingAmount).length)
        ); // Truncate the value
      }else if (staticPendinAfterConcession && parseFloat(value) > staticPendinAfterConcession) {
        error = "Amount can't exceed amount pending.";
        numericValue = Number(
          value.slice(0, String(staticPendinAfterConcession).length)
        ); // Truncate the value
      }
    }
    // Update state
    setTotalAmountPaid(numericValue); // Set the updated value
    setTotalAmountPaidError(error); // Set the error message
  };
  useEffect(() => {
    if (!isEditing) {
      const parsedTotalAmountPaid = parseFloat(totalAmountPaid) || 0;
      const parsedcurrentPendingAmount = parseFloat(currentPendingAmount) || 0;
      const parsedRefundBalance = parseFloat(refundBalance) || 0;
      const parsedStudentConcession = parseFloat(studentConcession) || 0;

      // Initialize variables
      let adjustedAmountAfterConcession = 0;
      let amountPending = parsedcurrentPendingAmount;

      let usedRefundAmount = 0;
      let remainingRefundBalance = parsedRefundBalance;

      // Calculate adjustedAmountAfterConcession if studentConcession is provided
      if (parsedStudentConcession > 0) {
        adjustedAmountAfterConcession =
          Math.max(0,parsedcurrentPendingAmount - parsedStudentConcession);
        setAmountAfterConcession(adjustedAmountAfterConcession);
        amountPending =
          adjustedAmountAfterConcession < 0 ? 0 : adjustedAmountAfterConcession;
      }
      // Adjust amountPending based on totalAmountPaid
      if (parsedTotalAmountPaid > 0) {
        amountPending -= parsedTotalAmountPaid;
      }

      console.log("Before refund logic:");
      console.log("remainingRefundBalance:", remainingRefundBalance);
      console.log("amountPending:", amountPending);

      // If refundBalanceInclude is checked, adjust amountPending
      if (refundBalanceInclude) {
        // Log values before Math.min
        console.log(
          "remainingRefundBalance before Math.min:",
          remainingRefundBalance
        );
        console.log("amountPending before Math.min:", amountPending);

        // Use the lesser of remaining refund or amountPending
        usedRefundAmount = Math.min(remainingRefundBalance, amountPending);

        console.log("Used Refund Amount after Math.min:", usedRefundAmount); // Ensure this value is correct

        // Update amountPending and remainingRefundBalance
        amountPending -= usedRefundAmount;

        remainingRefundBalance -= usedRefundAmount;

        // Ensure remainingRefundBalance does not drop below zero
        remainingRefundBalance = Math.max(remainingRefundBalance, 0);
        if (staticPendingAmount === null) {
          setStaticPendingAmount(amountPending);
        }


      }

      console.log("Updated amountPending after refund:", amountPending);
      console.log(
        "Updated remainingRefundBalance after refund:",
        remainingRefundBalance
      );

      // Ensure amountPending is not negative
      amountPending = Math.max(amountPending, 0);

      console.log("Final amountPending after all calculations:", amountPending);

      // Update the state with the calculated values
      setAmountPending(amountPending);
      setAmountAfterConcession(adjustedAmountAfterConcession);
      setRemainingRefundBalance(remainingRefundBalance);
      setUsedRefundAmount(usedRefundAmount);
    }
  }, [
    totalAmountPaid,
    currentPendingAmount,
    refundBalance,
    refundBalanceInclude,
    studentConcession,
  ]);

  const getPaymentMode = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/paymentMode/getPaymentMode", {
      method: "GET",
      headers: { "Content-type": "application/json" },
      credentials: "include",
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect to sign-in
          return null; // Stop further execution
        }
        return response.json();
      })
      .then((response) => {
        if (!response) return; // Prevent further execution if redirected
        setPaymentMode(response);
      })
      .catch((error) => {
        console.error("Error fetching payment modes:", error);
      });
  };
  
  useEffect(() => {
    getPaymentMode();
  }, []);

  const handleTransactionIdPopup = () => {
    setFeesSlabModal(false);
  };

  //download reciept
  const handleDownload = (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();
   
     // ✅ One line — reads from global config
  const institute = getInstituteConfig(instituteId);

    // Add Logo and Header
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    const textyy = 11;
    doc.setFont("helvetica", "bold");

    // School name
    doc.text(
      institute.name,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textyy,
      { align: "center" }
    );

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 8, 1, 28, 18);  // ✅ dynamic
    }

    // Address
    doc.setTextColor(0, 0, 0);
    const textStartY = 15;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 10,
      { align: "center" }
    );
    doc.text(
      institute.address2,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" }
    );
    if (institute.tel) {
      doc.text(
        institute.tel,  // ✅ dynamic, skipped for JPS
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 18,
        { align: "center" }
      );
    }

    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 30; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "FEES PAYMENT RECEIPT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    ); // Center aligned title
    doc.setFontSize(10);
    let studentDetailsY = receiptTextY + 10; // Adjust Y position after receipt info

    // Set font for student name and details
    doc.setFont('helvetica', 'bold');
    const studentLabelX = 14;

  // Constants for padding and maximum widths
const PADDING = 5; // Uniform padding between elements
const MAX_NAME_WIDTH = 70; // Max width for student name before wrapping

// Handle long student name
const studentname = `${studentName || ""}`;
const studentNameWidth = doc.getTextWidth(studentname);
const splitStudentName =
  studentNameWidth > MAX_NAME_WIDTH
    ? doc.splitTextToSize(studentname, MAX_NAME_WIDTH)
    : studentname;

doc.text(`Name of Student: `, studentLabelX, studentDetailsY); // Left aligned
doc.setFont('helvetica', 'normal');
doc.text(splitStudentName, studentLabelX + 30, studentDetailsY); // Adjust X position for student name

// Dynamically calculate X position for Grade based on student name
const studentNameActualWidth = Math.min(studentNameWidth, MAX_NAME_WIDTH); // Use actual width or max width
const gradeX = studentLabelX + 30 + studentNameActualWidth + PADDING;

// Grade
doc.setFont('helvetica', 'bold');
doc.text(`Grade:`, gradeX, studentDetailsY);
const gradeLabelWidth = doc.getTextWidth(`Grade: `);
doc.setFont('helvetica', 'normal');
const gradeValue = `${gradeName || ''}`;
doc.text(gradeValue, gradeX + gradeLabelWidth, studentDetailsY);

// Dynamically calculate X position for Section based on Grade
const gradeValueWidth = doc.getTextWidth(gradeValue);
const sectionX = gradeX + gradeLabelWidth + gradeValueWidth + PADDING;

// Section
doc.setFont('helvetica', 'bold');
doc.text(`Section:`, sectionX, studentDetailsY);
const sectionLabelWidth = doc.getTextWidth(`Section: `);
doc.setFont('helvetica', 'normal');
const sectionValue = `${sectionName || ''}`;
const sectionValueWidth = doc.getTextWidth(sectionValue);

// Check if Section exceeds page width and adjust
if (sectionX + sectionLabelWidth + sectionValueWidth > doc.internal.pageSize.width) {
  // Move to the next line if it exceeds the page width
  studentDetailsY += 10; // Adjust Y position
  doc.text(`Section:`, studentLabelX, studentDetailsY); // Start from the left
  doc.text(sectionValue, studentLabelX + sectionLabelWidth, studentDetailsY);
} else {
  // Place Section normally
  doc.text(sectionValue, sectionX + sectionLabelWidth, studentDetailsY);
}

    // Table for Particulars (example data)
    const receiptDetails = [
      { title: "Fee Payment ID", value: row.fees_payment_id },
      // { title: "Fees Slab", value: feesSlabAmount },
      { title: "Amount Paid", value: row.amount_paid },
      { title: "Amount Pending", value: row.pending_amount },
      { title: "Payment Date", value: row.payment_date },
      { title: "Payment Mode", value: row.payment_mode_name },
      { title: "Transaction ID", value: row.transaction_id || "N/A" },
      { title: "Refund Amount Used", value: row.refund_amount_used },
      { title: "Description", value: row.description },
    ];

  
    doc.autoTable({
      head: [["Particulars", "Amount"]],
      body: receiptDetails.map((item) => [item.title, item.value]),
      startY: receiptTextY + 13, // Start table below student details
      styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        halign: "left", // Center-align header text
      },
      bodyStyles: {
        halign: "left", // Align text to the left in the body
      },
      columnStyles: {
        0: { cellWidth: 90, halign: "left" }, // Fixed width for the "Particulars" column
        1: { cellWidth: 90, halign: "left" }, // Fixed width for the "Amount" column
      },
      theme: "grid",
    });
    const currentDate = new Date();

    // Format the date as DD/MM/YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0"
    )}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    doc.setFont("helvetica", "bold");
    doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
    doc.setFont("helvetica", "bold");
    doc.text("Authorized Signatory", 158, doc.previousAutoTable.finalY + 40); // Right aligned for signature

    // Save the PDF
    doc.save(
      `fees-payment-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
    );
  };

  const { isOtpEnabled } = useOtpSettings();

  const handleGetOtp = async () => {
    // Check if OTP is enabled for FeePayment
    const otpRequiredForFeePayment = isOtpEnabled('FeePayment');
    
    if (!otpRequiredForFeePayment) {
      // OTP is disabled, save directly
       // ✅ Check for changes before saving (same logic as OTP path)
    const hasChanges =
      oldTotalAmountPaid !== totalAmountPaid ||
      oldStudentConcession !== studentConcession ||
      oldAmountPending !== amountPending ||
      oldPaymentMode !== paymentModeName ||
      oldUtrId !== utrId ||
      oldPaymentDate !== paymentDate ||
      oldDescription !== description;

    if (!hasChanges) {
      setSnackbarMessage("No changes detected.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return;
    }

      savePaymentDetails();
      return;
    }
    
    setSnackbarMessage("OTP sent successfully.");
    setSnackbarMessageColor("success");
    setShowSnackbarMessage(true);
    
    try {
      const paymentDetails = {

        fee_concession: studentConcession,
        amount_paid: totalAmountPaid,
        amount_pending: amountPending,
        payment_mode_name: paymentModeName,
        transaction_id: utrId,
        payment_date: paymentDate,
        refund_amount: refundBalance,
        description: description,
      
      };
      const paymentType= "Fee Payment"
      const paymentId = feePaymentId;
  
      // Assuming you have a way to get the oldPaymentDetails
      const oldPaymentDetails = {
  
        amount_paid: oldTotalAmountPaid,
        fee_concession: oldStudentConcession,
        amount_pending: oldAmountPending,
        payment_mode_name: oldPaymentMode,
        transaction_id: oldUtrId,
        payment_date: oldPaymentDate,
        description: oldDescription,
        refund_amount: refundBalance
      };
      setEmail(process.env.REACT_APP_EMAIL)
  
      const response = await axios.post(process.env.REACT_APP_JHS_DEVELOPMENT+'/send-otp/getOtp',{
        email,
        userMail,
        paymentId,
        updatedPaymentDetails: paymentDetails,
        oldPaymentDetails: oldPaymentDetails, // Include old details here
        userId: userId,
        paymentType,studentName,gradeName,sectionName
      },{ withCredentials: true });
    
      if (response.data.otp) {  
      setBackendOtp(response.data.otp);
          setOtpSent(true);
          setResendTimer(600);
          setCanResend(false);
          setOtp(['', '', '', '', '', '']); 
          setIsOtpModalOpen(true); // Open OTP modal
          
          
      }
    

    } catch (error) {
      console.error('Error sending OTP:', error);
        setSnackbarMessage("No changes detected.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
        
        if (error.status === 401) {
          console.warn("Unauthorized access. Redirecting to Sign In...");
          navigate("/signin"); // ✅ Fix: Ensure correct spelling
          return;
        }
  // setTimeout (()=>{
  //   reset();
  // },2000)

    
    }
  };

const handleVerifyOtp = (event) => {
  event.preventDefault();
  const enteredOtp = otp.join(""); // Combine the entered OTP from the input boxes

  // Check if the OTP field is empty
  if (!enteredOtp) {
    setVerifyOTPMsg("Please enter the OTP");
    return;
  }

  // Check if the entered OTP matches the backend OTP
  if (enteredOtp === backendOtp) {
    setVerifyOTPMsg("OTP Verified Successfully");
    savePaymentDetails();
    setIsOtpModalOpen(false); // Close the modal on successful verification
    setOtp(["", "", "", "", "", ""]);
    setVerifyOTPMsg(''); // Clear any verification message
  setResendCount(0); // Reset resend count
  setResendTimer(600); // Reset resend timer
  setCanResend(true); // Disable resend button
  } else {
    setVerifyOTPMsg("Invalid OTP"); // Show this if the OTP is incorrect
  }
  setUpdate(true);
  
};

const handleOtpChange = (e, index) => {
  const value = e.target.value;
  if (/^[0-9]$/.test(value) || value === "") {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Focus on the next input
    if (value !== "" && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
    // Focus on the previous input
    if (value === "" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  }
};

  // Add this useEffect to handle the countdown timer
useEffect(() => {
  let intervalId;
  
  if (isOtpModalOpen && resendTimer > 0 && !canResend) {
    intervalId = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer <= 1) {
          setCanResend(true);
          clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  }

  return () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
}, [isOtpModalOpen, canResend, resendTimer]);
 

// Format time to MM:SS
const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

const handleResendOtp = () => {
  if (canResend && resendCount < 3) {
    setResendCount(prev => prev + 1);
    handleGetOtp(); // Triggers OTP generation and email
    setCanResend(false); // Disable until timer ends
    setResendTimer(600);  // Restart the timer
  } else {
    setVerifyOTPMsg("You have reached the maximum number of resend attempts.");
  }
};


const handleCloseModal = () => {
  setIsOtpModalOpen(false);

  // Reset all states related to OTP input, verification, and timers
  setOtp(['', '', '', '', '', '']); // Reset OTP fields
  setVerifyOTPMsg(''); // Clear any verification message
  setResendCount(0); // Reset resend count
  setResendTimer(600); // Reset resend timer
  setCanResend(true); // Disable resend button
  setFeePaymentId("")
  reset();
};
  return (
    <div>
      <div className="main_title">Fee Payment</div>
      <br />
      <Dialog onClose={handleTransactionIdPopup} open={feesSlabModal}>
        <DialogTitle
          alignSelf={"left"}
          style={{
            paddingBottom: "0",
            marginLeft: "9px",
            marginRight: "6px",
            color: "#0A64A2",
          }}
        >
          {feePaymentId
            ? paymentModeName === "DD/Cheque"
              ? "Edit DD/Cheque No"
              : "Edit Transaction ID"
            : paymentModeName === "DD/Cheque"
            ? "Add DD/Cheque No"
            : "Add Transaction ID"}
          <Divider className="divider" />
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleTransactionIdPopup}
          size="small"
          className="icon-button"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Stack spacing={4} padding={1}>
            <TextField
              id="outlined-basic"
              value={utrId}
              onChange={(event) => {
                setUrtId(event.target.value);
                setTransactionIdError("");
              }}
              size="small"
              inputProps={{ maxLength: 20 }}
              error={!!transactionIdError}
              label={
                transactionIdError
                  ? transactionIdError // Show error as label if present
                  : paymentModeName === "DD/Cheque"
                  ? "Enter DD/Cheque No" // Change label based on payment mode
                  : "Enter Transaction ID"
              } // Default label
              variant="outlined"
            />

            <div className="button-container">
              <Button
                className="save_update_btn"
                variant="contained"
                onClick={() => {
                  setFeesSlabModal(false);

                  let transactionIdError = "";

                  if (
                    (paymentModeName === "UPI" || paymentModeName === "DD/Cheque") &&
                    (!utrId || utrId.trim() === "")
                  ) {
                    transactionIdError = paymentModeName === "DD/Cheque" 
                      ? "DD/Cheque number is required." 
                      : "Transaction ID is required.";
                  }
                  
                  if (transactionIdError) {
                    setFeesSlabModal(true);
                    setTransactionIdError(transactionIdError);
                    return;
                  }
                  
                  setTransactionIdError("");
                  
                }}
              >
                {feePaymentId ? <>Update</> : <>Save</>}
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>
      <div className="form-container">
        <Stack spacing={8} direction="row" className="form-stack">
          <Stack spacing={1} direction="column" className="form-stack">
            {/* Solved Debug  */}
            {/* Simran edited textfields */}
            <TextField
              id="outlined-basic"
              disabled
              type="number"
              value={feeSlab}
              size="small"
              label={
                feesSlabError
                  ? feesSlabError
                  : "Fee Slab"
              }
              error={!!feesSlabError}
              variant="outlined"
              inputProps={{ maxLength: 10 }}
              InputLabelProps={{ shrink: true }}
              className="text-field"
            />
            <TextField
              disabled={((studentConcession === amountPending || studentConcession === "") && amountPending === 0)||feePaymentId}
          //  disabled={((totalAmountPaid === amountPending || totalAmountPaid === "") && amountPending === 0) || feePaymentId}
              id="outlined-basic"
              type="number"
              name="student_concession"
              value={studentConcession}
              onChange={(event) => {
                handleStudentConcessionChange(event);
              }}
              onFocus={() => {
                // Clear the field when it's focused and the initial value is 0
                if (studentConcession === 0) {
                  setStudentConcession("");
                }
              }}
              label={
                studentConcessionError
                  ? studentConcessionError
                  : "Student Concession"
              }
              variant="outlined"
              size="small"
              inputProps={{ maxLength: 10 }}
              InputLabelProps={{ shrink: true }}
              error={!!studentConcessionError}
              className="text-field"
            />
            <TextField
              id="outlined-basic"
              className="text-field"
              disabled
              type="number"
              value={amountAfterConcession}
              onChange={(event) => {
                setAmountAfterConcession(event.target.value);
              }}
              size="small"
              label="Amount after concession"
              variant="outlined"
            />
          </Stack>
          <Stack spacing={1} direction="column">
            <TextField
              // disabled={((totalAmountPaid === amountPending || totalAmountPaid === "") && amountPending === 0) || feePaymentId}
              disabled={((totalAmountPaid === amountPending || totalAmountPaid === "" || isNaN(totalAmountPaid)) && amountPending === 0) || feePaymentId}

              id="outlined-basic"
              error={!!totalAmountPaidError}
              type="number"
              value={totalAmountPaid}
              size="small"
              onChange={(event) => {
                handleAmountPaidChange(event);
              }}
              onFocus={() => {
                // Clear the field when it's focused and the initial value is 0
                if (totalAmountPaid === 0) {
                  setTotalAmountPaid("");
                }
              }}
              label={
                totalAmountPaidError
                  ? totalAmountPaidError
                  : "Total Amount Paid"
              }
              required
              variant="outlined"
              inputProps={{ maxLength: 10 }}
              className="text-field"
            />
            <TextField
              id="outlined-basic"
              className="text-field"
              disabled
              type="number"
              value={amountPending}
              onChange={(event) => {
                setAmountPending(event.target.value);
              }}
              size="small"
              label="Total Amount Pending"
              variant="outlined"
              inputProps={{ maxLength: 10 }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              id="outlined-basic"
              className="text-field"
              error={!!paymentDateError}
              type="date"
              required
              // inputProps={{ max: new Date().toISOString().split("T")[0] }}
              defaultValue={null}
              value={paymentDate}
              name="paymentDate"
              onChange={(event) => {
                setPaymentDate(event.target.value);
                
              }}
              size="small"
              variant="outlined"
              label={paymentDateError ? paymentDateError : "Payment Date"}
              InputLabelProps={{ shrink: true }}
              sx={{
                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                  cursor: "pointer", // Change cursor to pointer for the calendar icon
                },
              }}
            />
          </Stack>

          <Stack spacing={1} direction="column">
            <Stack direction="row" spacing={1}>
              <TextField
                id="outlined-basic"
                // style={{ width: 190 }}
                className="text-field"
                disabled
                type="number"
                value={refundBalance}
                onChange={(event) => {
                  setRefundBalance(event.target.value);
                }}
                name="refund"
                size="small"
                label="Refund Balance"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={refundBalanceInclude}
                    onChange={() => {
                      handleRefundChange();
                    }}
                  />
                }
                label="Include"
                inputProps={{ maxLength: 10 }}
              />
            </Stack>

            <TextField
              // style={{ width: 190 }}
              className="text-field"
              size="small"
              label={
                paymentModeError ? paymentModeError : "Select Payment Mode"
              }
              error={!!paymentModeError}
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={paymentModeName}
              name="paymentModeName"
              select
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            >
              {paymentMode.map((pm) => {
                return (
                  <MenuItem
                    key={pm.payment_mode_id}
                    value={pm.payment_mode_name}
                  >
                    {pm.payment_mode_name}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
              className="text-field"
              id="outlined-basic"
              onClick={() => {
                if (!paymentModeName || paymentModeName === "Cash") {
                  setFeesSlabModal(false);
                } else {
                  setFeesSlabModal(true);
                }
              }}
              disabled={
                !paymentModeName ||
                paymentModeName === "Cash" ||
                paymentModeName === "Using Refund Balance"
              } 

              value={utrId}
              onChange={(event) => {
                const value = event.target.value;
                setUrtId(value);
                setTransactionIdError("");
              }}
              size="small"
              variant="outlined"
              InputProps={{
                readOnly: true,
                maxLength: 20,
              }}
              InputLabelProps={{ shrink: true }}
              error={!!transactionIdError}
              label={
                transactionIdError
                  ? transactionIdError // Show error as label if present
                  : paymentModeName === "DD/Cheque"
                  ? "Enter DD/Cheque No" // Change label based on payment mode
                  : "Enter Transaction ID"
              } 
            />
          </Stack>
          <Stack spacing={1} direction="column">
            <TextField
              id="outlined-basic"
              disabled
              multiline
              // style={{ width: 300 }}
              className="description-field-feePayment"
              rows={2}
              type="text"
              value={remarks}
              onChange={(event) => {
                setRemark(event.target.value);
              }}
              size="small"
              label="Remarks"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              id="outlined-multiline-static"
              multiline
              rows={2}
              value={description}
              onChange={(event) => {
                const value = event.target.value
                setDescription(value);
                // setOldDescription(description)
              }}
              size="small"
              label="Description"
              variant="outlined"
              inputProps={{ maxLength: 250 }}
              // InputLabelProps={{ shrink: true }}
            />
           
            <Button
              className="save_update_btn"
              variant="contained"
               disabled={isLoading}
              onClick={() => {
                if (feePaymentId) {
                  let totalAmountPaidError = "";
                  let paymentDateError = "";
                  let paymentModeError = "";
                  let transactionIdError = "";
                  let feesSlabError = "";
              
                  if (!currentPendingAmount === 0) {
                    if (!totalAmountPaid || parseFloat(totalAmountPaid) === 0) {
                      totalAmountPaidError = "Amount paid is required";
                    }
                  }
              
                  // Validate Payment Date
                  if (!paymentDate || paymentDate.trim() === "") {
                    paymentDateError = "Payment Date is required";
                  }
              
                  // Validate Payment Mode
                  if (
                    !paymentModeName ||
                    paymentModeName === "" ||
                    parseFloat(paymentModeName) === 0
                  ) {
                    paymentModeError = "Payment Mode is Required";
                  }
                
              
              if ( (paymentModeName === "UPI" || paymentModeName === "DD/Cheque") && (!utrId || utrId.trim() === "")) {
                transactionIdError = paymentModeName === "DD/Cheque" 
               ? "DD/Cheque number is required." 
               : "Transaction ID is required.";
                }

                if ((!feesSlabAmount || parseFloat(feesSlabAmount) === 0 || feesSlabAmount === "")){
                  feesSlabError = "Fees Slab is required";
                  setSnackbarMessage("Fees slab must be added for this student before proceeding with the payment.");
                  setSnackbarMessageColor("error");
                  setShowSnackbarMessage(true);
            
                }
                  // Set errors and return if any validations fail
                  if (
                    totalAmountPaidError ||
                    paymentDateError ||
                    paymentModeError ||
                    transactionIdError ||
                    feesSlabError
                  ) {
                    setTotalAmountPaidError(totalAmountPaidError);
                    setPaymentDateError(paymentDateError);
                    setTransactionIdError(transactionIdError);
                   setFeesSlabError(feesSlabError);
                    setPaymentModeError(paymentModeError);
                    return; // Prevent form submission if there are errors
                  }
              
                  // Reset error state after successful validation
                  setTotalAmountPaidError("");
                  setPaymentDateError("");
                  setTransactionIdError("");
                  setPaymentModeError("");
                  setFeesSlabError("");
                  handleGetOtp();
            
                } else {
                  addPaymentDetails();
                }
              }}
              style={{ alignSelf: "flex-end" }}
              backgroundColor="#0A64A2"
            >
                {isLoading ? "Saving..." : feePaymentId ? "Update" : "Save"}
            </Button>
          </Stack>
        </Stack>
      </div>
      <br />

      <div className="main_title">
        Fee Payments of {studentName}{" "}
        {currentPendingAmount === 0 && feesSlabAmount>0 && <span>(Paid in full)</span>}
      </div>
      <Box className="table-container">
        <Paper className="table-paper">
          <TableContainer component={Paper}>
            <Table >
              <TableHead className="table-header">
                <TableRow>
                  <TableCell align="center" >
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "fees_payment_id"}
                      direction={orderBy === "fees_payment_id" ? order : "desc"}
                      onClick={() => handleRequestSort("fees_payment_id")}
                    >
                      Fees Payment ID
                      {orderBy === "fees_payment_id" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center" >
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "amount_paid"}
                      direction={orderBy === "amount_paid" ? order : "desc"}
                      onClick={() => handleRequestSort("amount_paid")}
                    >
                      Amount Paid
                      {orderBy === "amount_paid" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>

                  <TableCell align="center">
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "fee_concession"}
                      direction={orderBy === "fee_concession" ? order : "desc"}
                      onClick={() => handleRequestSort("fee_concession")}
                    >
                      Concession
                      {orderBy === "fee_concession" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "refund_amount"}
                      direction={orderBy === "refund_amount" ? order : "desc"}
                      onClick={() => handleRequestSort("refund_amount")}
                    >
                      Refund Used
                      {orderBy === "refund_amount" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "pending_amount"}
                      direction={orderBy === "pending_amount" ? order : "desc"}
                      onClick={() => handleRequestSort("pending_amount")}
                    >
                      Amount Pending
                      {orderBy === "pending_amount" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">
                    
                      <TableSortLabel
                        className="table-sort-label "
                        active={orderBy === "payment_date"}
                        direction={orderBy === "payment_date" ? order : "desc"}
                        onClick={() => handleRequestSort("payment_date")}
                      >
                        Date
                        {orderBy === "payment_date" ? (
                          <span style={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                 
                  </TableCell>
                  <TableCell align="center">
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "payment_mode_name"}
                      direction={
                        orderBy === "payment_mode_name" ? order : "desc"
                      }
                      onClick={() => handleRequestSort("payment_mode_name")}
                    >
                      Payment Mode
                      {orderBy === "payment_mode_name" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">
                    <TableSortLabel
                      className="table-sort-label "
                      active={orderBy === "description"}
                      direction={orderBy === "description" ? order : "desc"}
                      onClick={() => handleRequestSort("description")}
                    >
                      Description
                      {orderBy === "description" ? (
                        <span style={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell className="table-sort-label-recipt">
                    Receipt
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? sortedRows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : sortedRows
                ).map((row, i) => (
                  <StyledTableRow
                    key={row.fees_payment_id}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleSelectRow(
                        row.fees_payment_id,
                        row.amount_paid,
                        row.pending_amount,
                        row.remarks,
                        // row.refund_amount_used,
                        row.fee_concession,
                        row.payment_mode_name,
                        row.payment_date,
                        row.transaction_id,
                        row.description,
                 
                      );
                    }}

             
                  >
                    <StyledTableCell
                      align="center"
                     
                    >
                      {row.fees_payment_id}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                     
                    >
                      {row.amount_paid}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      
                    >
                      {row.fee_concession}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      
                    >
                      {row.refund_amount_used}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      
                    >
                      {row.pending_amount}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                     
                    >
                     
                      {row.payment_date}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                     
                    >
                      {row.payment_mode_name}
                      {row.transaction_id && (
                        <>
                          <br />({row.transaction_id})
                        </>
                      )}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      
                    >
                      {row.description}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Button
                        onClick={(event) => handleDownload(row, event)}
                        variant="text"
                        startIcon={<DownloadIcon />}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    sx={{
                      backgroundColor: "#0A64A2",
                      color: "white",
                      width: "100%",
                    }}
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={9}
                    count={feesPayment.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    
      <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
  <Box className="modalStyle">
    {/* Close Button in the top-right corner */}
    <IconButton
      aria-label="close"
      onClick={handleCloseModal}
      style={{ position: 'absolute', top: 7, right: 10 }}
    >
      <CloseIcon />
    </IconButton>

    <h3 className="enter-otp">Enter OTP</h3>
    <Divider className="divider" />
    {verifyOTPMsg && (
      <p className="invalid-otp">
        {verifyOTPMsg}
      </p>
    )}

    {/* OTP Input Boxes */}
    <div className="otp-container">
      {otp.map((data, index) => (
        <TextField
  key={index}
  autoFocus={index === 0} 
  value={data}
  onChange={(e) => handleOtpChange(e, index)}
  inputProps={{
    maxLength: 1,
    id: `otp-input-${index}`, // Set id for focus management
    style: {
      textAlign: "center", // Center the text inside
      fontSize: "17px", // Font size adjustment
      width: "40px", // Set width and height equal to make it square
      height: "40px", // Set width and height equal to make it square
      padding: 0, // Remove default padding
      boxSizing: "border-box", // Ensure borders don't affect the box size
    },
  }}
  InputProps={{
    style: {
      textAlign: "center",
    },
  }}
  sx={{
    '& .MuiInputBase-input': {
      padding: 0, // Remove extra padding to keep it square
    },
  }}
/>

      ))}
    </div>

    {/* Verify and Resend OTP Message */}
    <div className="otp-btn-container">
      {/* Resend OTP Control */}
 {canResend ? (
  <p
    className="resend-otp"
    style={{ color: "green", cursor: "pointer" }}
    onClick={handleResendOtp}
  >
    Resend OTP {resendCount}/3
  </p>
) : (
  <p style={{ color: "red" }}>
    Resend OTP in {formatTime(resendTimer)}
  </p>
)}

      <Button
        variant="contained"
        onClick={handleVerifyOtp} // Use handleVerifyOtp for verification
        className="verify-btn"
      >
        Verify
      </Button>
    </div>
  </Box>
</Modal>

    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));